import Textarea from "@/components/ui/textarea";
import { useUpdateAccountPropertiesMutation } from "@api/accounts";
import Button from "@components/ui/button";
import Spinner from "@components/ui/spinner";
import { cn } from "@lib/cn";
import { useAppDispatch } from "@store";
import { setDialogId } from "@store/global-slice";
import { useState } from "react";
import { toast } from "react-toastify";
import { useCurrentAccount } from "../providers/current-account-provider";

const SALES_V4_ACCOUNT_ID = "85fed0770673b983f31c86476329d781";

export const LeadGenerationPrompt = () => {
  const { account, isDifferentFromCurrentAccount } = useCurrentAccount();
  const dispatch = useAppDispatch();
  const [isTextareaEnabled, setIsTextareaEnabled] = useState(false);
  const [value, setValue] = useState<string>(account?.leadCapturePrompt || "");
  const [updateAccountProperties, { isLoading }] =
    useUpdateAccountPropertiesMutation();

  const onSubmit = async () => {
    if (isLoading) return;
    try {
      await updateAccountProperties({
        type: "account",
        payload: { leadCapturePrompt: value },
        id: account?._id as string,
      }).unwrap();
      if (isDifferentFromCurrentAccount) {
        toast.success(
          `${account?.title} lead capture prompt updated successfully`,
        );
      } else {
        toast.success("Lead capture prompt updated successfully");
        window.location.reload();
      }
    } catch (error) {
      toast.error("Failed to update fonts");
    }
    dispatch(setDialogId({ id: null }));
  };
  if (account?._id !== SALES_V4_ACCOUNT_ID) return null;

  return (
    <>
      <hr className="tw-my-6 tw-border-t tw-border-blue-100" />
      <div>
        <span className="tw-mb-1 tw-block tw-font-sans tw-text-[13px]/normal tw-font-semibold tw-text-blue-base">
          Hubspot prompt
        </span>
        <Textarea
          className="tw-h-24"
          disabled={!isTextareaEnabled}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <div className="tw-mt-6 tw-flex tw-items-center tw-gap-2">
          <Button
            onClick={onSubmit}
            variant="secondary"
            disabled={!isTextareaEnabled}
            className={cn(isLoading && "tw-cursor-not-allowed")}
          >
            {isLoading ? (
              <>
                <Spinner className="tw-mr-2 tw-size-3" /> Updating...
              </>
            ) : (
              "Update prompt"
            )}
          </Button>
          {!isTextareaEnabled && (
            <Button
              variant="outline"
              className="tw-border-[transparent] hover:tw-border-[transparent]"
              onClick={() => setIsTextareaEnabled(!isTextareaEnabled)}
            >
              Enable textarea
            </Button>
          )}
        </div>
      </div>
    </>
  );
};
